var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileOutline = function SvgFileOutline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.444 25C21.853 25 23 23.878 23 22.5V12C23 11.751 22.907 11.512 22.74 11.328L17.296 5.328C17.107 5.119 16.838 5 16.555 5H9.555C8.146 5 7 6.122 7 7.5V22.5C7 23.878 8.146 25 9.555 25H20.444ZM8.4 7.5C8.4 6.92352 8.89057 6.4 9.555 6.4H14.3V10C14.3 12.0435 15.9565 13.7 18 13.7H21.6V22.5C21.6 23.0758 21.1092 23.6 20.444 23.6H9.555C8.89057 23.6 8.4 23.0765 8.4 22.5V7.5ZM18 12.3C16.7297 12.3 15.7 11.2703 15.7 10V6.4H16.3783L21.6 12.155V12.3H18Z",
    fill: "#B0B5C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-outline.78434e65.svg";
export { ForwardRef as ReactComponent };